// import React, { useState } from 'react';
// import { warehousesAPI } from '../../api/warehouses';
// import { stocksAPI } from '../../api/stocks';
// import { useOfflineData } from '../../hooks/useOfflineData';
// import { canPerform, filterWarehouses } from '../../utils/permissions';
// import { dbHelpers } from '../../db/database';
// import './WarehouseManagement.css';
// import { useModal } from '../../hooks/useModal';
// import Modal from '../common/Modal';


// function WarehouseManagement() {
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [editingWarehouse, setEditingWarehouse] = useState(null);
//   const { isOpen, modalConfig, openModal, closeModal, confirm } = useModal();
//   const [formData, setFormData] = useState({
//     name: '',
//     location: '',
//     is_active: true
//   });
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const canManage = canPerform('warehouses', 'create');

//   // Load warehouses using hook
//   const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
//     () => warehousesAPI.getAll(),
//     dbHelpers.getWarehouses
//   );

//   // Load stocks using hook
//   const { data: stocks, loading: stocksLoading } = useOfflineData(
//     () => stocksAPI.getAll(),
//     dbHelpers.getStocks
//   );

//   const loading = warehousesLoading || stocksLoading;
//   const warehouses = filterWarehouses(allWarehouses);

//   function handleInputChange(e) {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setError('');
//     setSuccess('');

//     if (!formData.name || !formData.location) {
//       setError('Please fill in all required fields');
//       return;
//     }

//     try {
//       if (editingWarehouse) {
//         await warehousesAPI.update(editingWarehouse.id, formData);
//         setSuccess('Warehouse updated successfully!');
//       } else {
//         await warehousesAPI.create(formData);
//         setSuccess('Warehouse added successfully!');
//       }

//       setFormData({
//         name: '',
//         location: '',
//         is_active: true
//       });
//       setShowAddForm(false);
//       setEditingWarehouse(null);
      
//       // Reload page to refresh data
//       setTimeout(() => window.location.reload(), 50);
//     } catch (err) {
//       setError(err.response?.data?.detail || 'Failed to save warehouse');
//     }
//   }

//   function handleEdit(warehouse) {
//     setEditingWarehouse(warehouse);
//     setFormData({
//       name: warehouse.name,
//       location: warehouse.location,
//       is_active: warehouse.is_active !== false
//     });
//     setShowAddForm(true);
//     setError('');
//     setSuccess('');
//   }

//    async function performDelete(warehouse) {
//     try {
//       await warehousesAPI.delete(warehouse.id);      
//       setTimeout(() => window.location.reload(), 50);
      
//       closeModal();
//     } catch (err) {
//       setError('Failed to delete warehouse');
//       closeModal();
//     }
//   }

//  function handleDelete(warehouse) {
//     openModal({
//       title: 'Delete Warehouse?',
//       message: `Are you sure you want to delete "${warehouse.name}"? This action cannot be undone.`,
//       type: 'danger',
//       confirmText: 'Delete Warehouse',
//       cancelText: 'Cancel',
//       onConfirm: () => performDelete(warehouse)
//     });
//   }

//   function cancelEdit() {
//     setShowAddForm(false);
//     setEditingWarehouse(null);
//     setFormData({
//       name: '',
//       location: '',
//       is_active: true
//     });
//     setError('');
//     setSuccess('');
//   }

//   function getTotalStock(warehouseId) {
//     return stocks
//       .filter(stock =>
//         String(stock.warehouse) === String(warehouseId) ||
//         String(stock.warehouse_id) === String(warehouseId)
//       )
//       .reduce((sum, stock) => sum + (stock.quantity || 0), 0);
//   }

//   function getProductCount(warehouseId) {
//     return stocks.filter(stock =>
//       String(stock.warehouse) === String(warehouseId) ||
//       String(stock.warehouse_id) === String(warehouseId)
//     ).length;
//   }

//   if (loading) {
//     return (
//       <div className="loading-screen">
//         <div className="spinner"></div>
//         <p>Loading warehouses...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="warehouse-management fade-in">
//       <div className="warehouse-header">
//         <div>
//           <h1>Warehouses</h1>
//           <p className="subtitle">{warehouses.length} warehouses</p>
//         </div>
//         {canManage && (
//           <button
//             className="btn-primary-small"
//             onClick={() => setShowAddForm(!showAddForm)}
//           >
//             {showAddForm ? '✕ Cancel' : '+ Add Warehouse'}
//           </button>
//         )}
//       </div>

//       {success && (
//         <div className="alert alert-success">
//           ✓ {success}
//         </div>
//       )}

//       {error && (
//         <div className="alert alert-error">
//           ✕ {error}
//         </div>
//       )}

//       {/* Modal Form */}
//       {showAddForm && canManage && (
//         <div className="modal-overlay" onClick={cancelEdit}>
//           <div className="add-warehouse-form" onClick={(e) => e.stopPropagation()}>
//             <h2>{editingWarehouse ? 'Edit Warehouse' : 'Add New Warehouse'}</h2>
//             <form onSubmit={handleSubmit}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Warehouse Name *</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     placeholder="Main Warehouse"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Location *</label>
//                   <input
//                     type="text"
//                     name="location"
//                     value={formData.location}
//                     onChange={handleInputChange}
//                     placeholder="123 Storage St, City"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label className="checkbox-label">
//                   <input
//                     type="checkbox"
//                     name="is_active"
//                     checked={formData.is_active}
//                     onChange={handleInputChange}
//                   />
//                   <span>Active</span>
//                 </label>
//               </div>

//               <div className="form-actions">
//                 <button type="button" className="btn-secondary" onClick={cancelEdit}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn-primary-small">
//                   {editingWarehouse ? 'Update Warehouse' : 'Add Warehouse'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {warehouses.length > 0 ? (
//         <div className="warehouses-grid">
//           {warehouses.map(warehouse => {
//             const totalStock = getTotalStock(warehouse.id);
//             const productCount = getProductCount(warehouse.id);

//             return (
//               <div key={warehouse.id} className="warehouse-card">
//                 <div className="warehouse-icon">🏭</div>
//                 <h3>{warehouse.name}</h3>
//                 <p className="warehouse-location">
//                   📍 {warehouse.location || 'No location set'}
//                 </p>

//                 <div className="warehouse-stats">
//                   <div className="stat-item">
//                     <span className="label">Total Stock</span>
//                     <span className="value">{totalStock.toLocaleString()}</span>
//                   </div>
//                   <div className="stat-item">
//                     <span className="label">Products</span>
//                     <span className="value">{productCount}</span>
//                   </div>
//                 </div>

//                 {canManage && (
//                   <div className="warehouse-actions">
//                     <button
//                       className="btn-edit"
//                       onClick={() => handleEdit(warehouse)}
//                       title="Edit warehouse"
//                     >
//                       ✏️ Edit
//                     </button>
//                     <button
//                       className="btn-delete"
//                       onClick={() => handleDelete(warehouse)}
//                       title="Delete warehouse"
//                     >
//                       🗑️ Delete
//                     </button>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       ) : (
//         <div className="empty-state">
//           <div className="empty-icon">🏭</div>
//           <h2>No Warehouses Yet</h2>
//           {canManage ? (
//             <p className="empty-hint">Click "Add Warehouse" to create your first warehouse!</p>
//           ) : (
//             <p className="empty-hint">Contact your administrator to set up warehouses.</p>
//           )}
//         </div>
//       )}

//       {/* Confirmation Modal */}
//       <Modal 
//         isOpen={isOpen}
//         onClose={closeModal}
//         {...modalConfig}
//       />
  
//     </div>
//   );
// }

// export default WarehouseManagement;
import React, { useState } from 'react';
import { warehousesAPI } from '../../api/warehouses';
import { stocksAPI } from '../../api/stocks';
import { useOfflineData } from '../../hooks/useOfflineData';
import { canPerform, filterWarehouses } from '../../utils/permissions';
import { dbHelpers } from '../../db/database';
import { useModal } from '../../hooks/useModal';
import { useToast } from '../../hooks/useToast';
import Modal from '../common/Modal';
import './WarehouseManagement.css';


function WarehouseManagement() {
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingWarehouse, setEditingWarehouse] = useState(null);
  const { isOpen, modalConfig, openModal, closeModal } = useModal();
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    is_active: true
  });
  const [error, setError] = useState('');

  const canManage = canPerform('warehouses', 'create');

  const { data: allWarehouses, loading: warehousesLoading, refetch: refetchWarehouses } = useOfflineData(
    () => warehousesAPI.getAll(),
    dbHelpers.getWarehouses
  );

  const { data: stocks, loading: stocksLoading } = useOfflineData(
    () => stocksAPI.getAll(),
    dbHelpers.getStocks
  );

  const loading = warehousesLoading || stocksLoading;

  // ✅ Local warehouses state so we can update without reload
  const [localWarehouses, setLocalWarehouses] = useState(null);
  const warehouses = localWarehouses ?? filterWarehouses(allWarehouses);

  function handleInputChange(e) {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!formData.name || !formData.location) {
      setError('Please fill in all required fields');
      return;
    }

    try {
      if (editingWarehouse) {
        const updated = await warehousesAPI.update(editingWarehouse.id, formData);
        // ✅ Update item in local state directly
        setLocalWarehouses(prev =>
          (prev ?? filterWarehouses(allWarehouses)).map(w =>
            w.id === editingWarehouse.id ? { ...w, ...formData } : w
          )
        );
        toast.success('✅ Warehouse updated successfully');
      } else {
        const created = await warehousesAPI.create(formData);
        // ✅ Add new item to local state directly
        setLocalWarehouses(prev =>
          [...(prev ?? filterWarehouses(allWarehouses)), created.data || { ...formData, id: Date.now() }]
        );
        toast.success('✅ Warehouse added successfully');
      }

      setFormData({ name: '', location: '', is_active: true });
      setShowAddForm(false);
      setEditingWarehouse(null);

    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to save warehouse');
    }
  }

  function handleEdit(warehouse) {
    setEditingWarehouse(warehouse);
    setFormData({
      name: warehouse.name,
      location: warehouse.location,
      is_active: warehouse.is_active !== false
    });
    setShowAddForm(true);
    setError('');
  }

  async function performDelete(warehouse) {
    try {
      await warehousesAPI.delete(warehouse.id);
      await dbHelpers.deleteWarehouse(warehouse.id);

      // ✅ Remove from local state directly — no reload needed
      setLocalWarehouses(prev =>
        (prev ?? filterWarehouses(allWarehouses)).filter(w => w.id !== warehouse.id)
      );

      closeModal();
      toast.success('✅ Warehouse deleted successfully');
    } catch (err) {
      closeModal();
      toast.error('Failed to delete warehouse');
    }
  }

  function handleDelete(warehouse) {
    openModal({
      title: 'Delete Warehouse?',
      message: `Are you sure you want to delete "${warehouse.name}"? This action cannot be undone.`,
      type: 'danger',
      confirmText: 'Delete Warehouse',
      cancelText: 'Cancel',
      onConfirm: () => performDelete(warehouse)
    });
  }

  function cancelEdit() {
    setShowAddForm(false);
    setEditingWarehouse(null);
    setFormData({ name: '', location: '', is_active: true });
    setError('');
  }

  function getTotalStock(warehouseId) {
    return stocks
      .filter(stock =>
        String(stock.warehouse) === String(warehouseId) ||
        String(stock.warehouse_id) === String(warehouseId)
      )
      .reduce((sum, stock) => sum + (stock.quantity || 0), 0);
  }

  function getProductCount(warehouseId) {
    return stocks.filter(stock =>
      String(stock.warehouse) === String(warehouseId) ||
      String(stock.warehouse_id) === String(warehouseId)
    ).length;
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading warehouses...</p>
      </div>
    );
  }

  return (
    <div className="warehouse-management fade-in">
      <div className="warehouse-header">
        <div>
          <h1>Warehouses</h1>
          <p className="subtitle">{warehouses.length} warehouses</p>
        </div>
        {canManage && (
          <button
            className="btn-primary-small"
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm ? '✕ Cancel' : '+ Add Warehouse'}
          </button>
        )}
      </div>

      {error && (
        <div className="alert alert-error">
          ✕ {error}
        </div>
      )}

      {/* Modal Form */}
      {showAddForm && canManage && (
        <div className="modal-overlay" onClick={cancelEdit}>
          <div className="add-warehouse-form" onClick={(e) => e.stopPropagation()}>
            <h2>{editingWarehouse ? 'Edit Warehouse' : 'Add New Warehouse'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Warehouse Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Main Warehouse"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Location *</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="123 Storage St, City"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                  />
                  <span>Active</span>
                </label>
              </div>

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={cancelEdit}>
                  Cancel
                </button>
                <button type="submit" className="btn-primary-small">
                  {editingWarehouse ? 'Update Warehouse' : 'Add Warehouse'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {warehouses.length > 0 ? (
        <div className="warehouses-grid">
          {warehouses.map(warehouse => {
            const totalStock = getTotalStock(warehouse.id);
            const productCount = getProductCount(warehouse.id);

            return (
              <div key={warehouse.id} className="warehouse-card">
                <div className="warehouse-icon">🏭</div>
                <h3>{warehouse.name}</h3>
                <p className="warehouse-location">
                  📍 {warehouse.location || 'No location set'}
                </p>

                <div className="warehouse-stats">
                  <div className="stat-item">
                    <span className="label">Total Stock</span>
                    <span className="value">{totalStock.toLocaleString()}</span>
                  </div>
                  <div className="stat-item">
                    <span className="label">Products</span>
                    <span className="value">{productCount}</span>
                  </div>
                </div>

                {canManage && (
                  <div className="warehouse-actions">
                    <button
                      className="btn-edit"
                      onClick={() => handleEdit(warehouse)}
                      title="Edit warehouse"
                    >
                      ✏️ Edit
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(warehouse)}
                      title="Delete warehouse"
                    >
                      🗑️ Delete
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-icon">🏭</div>
          <h2>No Warehouses Yet</h2>
          {canManage ? (
            <p className="empty-hint">Click "Add Warehouse" to create your first warehouse!</p>
          ) : (
            <p className="empty-hint">Contact your administrator to set up warehouses.</p>
          )}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
    </div>
  );
}

export default WarehouseManagement;